@if (selectedItems?.length >= 1) {
<div
  class="modal-footter network-floater-action-container"
  
>
  <div class="network-floater-action-container-body">
    <div class="network-floater-item-container">
      <div class="network-floater-item-container-left">
        <h1 class="network-floater-item-container-left-title">{{ selectedItems?.length }}</h1>
        <p class="network-floater-item-container-left-text">Selected</p>
      </div>
      <div class="network-floater-item-container-right-wrapper">
        <!-- Network Component Buttons -->
        @if (componentType === 'network') {
        <!-- Create Group Button -->
        <div
          class="network-floater-item-container-right hover:bg-[#F4F4F4]"
          style="border-left: 1px solid #d3dce8b2"
          (click)="onActionClick('createGroup')"
        >
          <span class="network-floater-item-container-right-line"></span>
          <img src="assets/images/group-icon-n.svg" alt="group-icon" width="32px" height="32px" />
          <p class="network-floater-item-container-right-text">Create Gr...</p>
        </div>

        <!-- Add to Group Button -->
        <div
          class="network-floater-item-container-right hover:bg-[#F4F4F4]"
          style="border-left: 1px solid #d3dce8b2"
          (click)="onActionClick('addToGroup')"
        >
          <span class="network-floater-item-container-right-line"></span>
          <span class="material-icons network-floater-item-container-right-icon">add</span>
          <p class="network-floater-item-container-right-text">Add to Gr...</p>
        </div>

        <!-- Connect All Button -->
        <div
          class="network-floater-item-container-right hover:bg-[#F4F4F4]"
          style="border-left: 1px solid #d3dce8b2"
          (click)="onActionClick('connectAll')"
        >
          <span class="network-floater-item-container-right-line"></span>
          <span class="material-icons network-floater-item-container-right-icon material-symbols-outlined">person_add</span>
          <p class="network-floater-item-container-right-text">Connect All</p>
        </div>
        }

        <!-- Suggestions Component Buttons -->
        @if (componentType === 'suggestions') {
        <!-- Add Button -->
        <div class="network-floater-item-container-right hover:bg-[#F4F4F4]" style="border-left: 1px solid #d3dce8b2" (click)="onActionClick('add')">
          <span class="network-floater-item-container-right-line"></span>
          <span
            class="material-icons network-floater-item-container-right-icon"
            [ngClass]="{ 'material-symbols-outlined material-icons-outlined': isFromNetworkSetup, 'material-icons': !isFromNetworkSetup }"
            [style.transform]="isFromNetworkSetup ? 'scaleX(-1)' : ''"
            >person_add</span
          >
          <p class="network-floater-item-container-right-text">Add</p>
        </div>
        }

        <!-- Remove Button (Common for both) -->
        <div
          class="network-floater-item-container-right hover:bg-[#F4F4F4]"
          style="border-left: 1px solid #d3dce8b2"
          (click)="onActionClick('remove')"
        >
          <span class="network-floater-item-container-right-line"></span>
          <span
            class="material-icons network-floater-item-container-right-icon"
            [ngClass]="{
              'material-symbols-outlined material-icons-outlined text-k-blue': isFromNetworkSetup,
              'material-icons text-red-500': !isFromNetworkSetup
            }"
            >remove_circle</span
          >
          <p class="network-floater-item-container-right-text" [ngClass]="{ 'text-k-blue': isFromNetworkSetup, 'text-red-500': !isFromNetworkSetup }">
            Remove
          </p>
        </div>

        <!-- Close Button (Common for both) -->
        <div
          class="network-floater-item-container-right hover:bg-[#F4F4F4]"
          (click)="onActionClick('close')"
          style="border-left: 1px solid #d3dce8b2"
        >
          <span class="network-floater-item-container-right-line"></span>
          <span class="material-icons network-floater-item-container-right-icon">close</span>
          <p class="network-floater-item-container-right-text">Close</p>
        </div>
      </div>
    </div>
  </div>
</div>
}
